import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { environment } from '../../../environments/environment';
import { User } from '../../models/cube';
import { selectUserDetails } from '../../store/selectors/auth.selectors';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'cube-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: false,
})
export class ToolbarComponent implements OnInit {
  @Output() onDepartmentClick: EventEmitter<any> = new EventEmitter<any>();

  @Input() drawer;
  @Input() matDrawerShow;
  @Input() sidebar;
  @Input() sidenav;

  currentUser?: Observable<User> = null;
  isSettingPanelEnabled = false;
  isSupportToolEnabled = true;
  isCollaudoEnv = environment.isCollaudoEnv;
  searchOpen = false;

  constructor(private store: Store) {}

  ngOnInit() {
    // TEMP: For B2C migration
    // INFO get user details from store
    this.currentUser = this.store.select(selectUserDetails);
  }

  onAction(action: any) {}

  onSearch(search: any) {}

  openSupportPage() {
    window.open(environment.supportUrl, '_blank');
  }
}
